// 消息信息管理
import { api } from "@/service/api";
import apiList from "@/service/apiList";
const typeName = type => {
  let text = "";
  switch (type) {
    case "1":
      text = "价格消息";
      break;
    case "2":
      text = "商品消息";
      break;
    case "3":
      text = "订单消息";
      break;
    case "4":
      text = "库存消息";
      break;
    default:
      break;
  }
  return text;
};
const state = {
  sysMessage: [], // 未读
  sysReadMessage: [], // 已读
  sysInterval: "", // 定时未读
  sysReadInterval: "", // 定时已读
  pending_order_flag: false, //是否有查询工单的消息
  pending_as_order_flag: false //是否展示强提醒售后消息框
};

const mutations = {
  // 设置未读消息列表
  CHANGE_MESSAGE: (state, message) => {
    state.sysMessage = message;
  },
  // 标记未读消息
  UPDATE_MESSAGE: (state, item) => {
    let inde;
    state.sysMessage.forEach((i, index) => {
      if (item.id === i.id) {
        inde = index;
      }
    });
    state.sysMessage.splice(inde, 1);
  },
  // 设置已读消息
  CHANGE_READMESSAGE: (state, message) => {
    state.sysReadMessage = message;
  },
  // 删除已读消息
  DELETE_READMESSAGE: (state, message) => {
    let inde;
    state.sysReadMessage.forEach((i, index) => {
      if (message.id === i.id) {
        inde = index;
      }
    });
    state.sysReadMessage.splice(inde, 1);
  },
  // 清除定时任务
  CLEAR_INTERVAL: state => {
    // console.log(state)
    clearInterval(state.sysInterval);
    clearInterval(state.sysReadInterval);
  },
  INTERVAL: (state, interval) => {
    state.sysInterval = interval;
  },
  READ_INTERVAL: (state, interval) => {
    state.sysReadInterval = interval;
  },
  PENDING_ORDER_FLAG: (state, flag) => {
    state.pending_order_flag = flag;
  },

  PENDING_AS_ORDER_FLAG: (state, flag) => {
    state.pending_as_order_flag = flag;
  }
};

const actions = {
  // 获取未读消息列表
  async changeMessage({ commit, dispatch }, message) {
    let getMessage = () => {
      api.get(apiList.getMessageList, { status: 0 }).then(res => {
        if (res.code === 200) {
          let list = res.data;
          list.forEach(item => {
            item.isRead = false;
            item.typeName = typeName(item.type);
            if (item.type === "4") {
              item.list = JSON.parse(item.content);
            }
          });
          commit("CHANGE_MESSAGE", list);
        }
      });
    };
    getMessage();
    dispatch("clearInterval");
    commit("INTERVAL", setInterval(getMessage, 180 * 1000));
  },
  // 标记未读消息
  async updateMessage({ commit }, item) {
    const data = await api.post(apiList.readMessage, { id: item.id });
    if (data.code === 200) {
      commit("UPDATE_MESSAGE", item);
    }
  },
  // 获取已读消息
  changeReadMessage({ commit }) {
    let getMessage = async () => {
      const data = await api.get(apiList.getMessageList, { status: 1 });
      if (data.code === 200) {
        let list = data.data;
        list.forEach(item => {
          item.typeName = typeName(item.type);
          item.isRead = true;
          if (item.type === "4") {
            item.list = JSON.parse(item.content);
          }
        });
        commit("CHANGE_READMESSAGE", list);
      }
    };
    getMessage();
    // commit('READ_INTERVAL', setInterval(getMessage, 180000))
  },
  // 删除已读消息
  deleteMessage({ commit }, message) {
    api.post(apiList.delMessage, { id: message.id }).then(res => {
      if (res.code === 200) {
        commit("DELETE_READMESSAGE", message);
      }
    });
  },
  // 清除定时任务
  clearInterval({ commit }) {
    commit("CLEAR_INTERVAL");
  },
  // 是否查询待处理工单列表
  isQueryPendingOrder({ commit }, flag) {
    commit("PENDING_ORDER_FLAG", flag);
  },
  // 是否展示强提醒售后消息框
  isQueryPendingAsOrder({ commit }, flag) {
    commit("PENDING_AS_ORDER_FLAG", flag);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js